import axios from 'axios';
import { POST_PAYMENT_COPMLETE ,GET_PAYMENTS_URL, POST_PAYMENT_CANCEL} from "../constants/index";


import { IPostCompleteData } from '../interfaces/balanceRequest';



export function getBalanceRequest(page: number, size: number) {
  return axios.get(GET_PAYMENTS_URL, {params: {
    page,
    size,
    sort: 'createdAt,desc',
  }});
}

export function postCompleteBalanceRequest(paymentId:string,data: IPostCompleteData) {
  return axios.post(POST_PAYMENT_COPMLETE(paymentId),data);
}

export function postCancelBalanceRequest(paymentId:string, data: IPostCompleteData) {
  return axios.post(POST_PAYMENT_CANCEL(paymentId),data);
}